// src/api/residenceApi.js
import axiosClient from "./axiosClient";

// ---------------- Residence Types ----------------

// Get all residence types
export const getResidenceTypes = () => axiosClient.get("/residence/types");

// Create a new residence type
export const createResidenceType = (typeData) =>
  axiosClient.post("/residence/types", typeData);

// Update an existing residence type
export const updateResidenceType = (id, typeData) =>
  axiosClient.put(`/residence/types/${id}`, typeData);

// Delete a residence type
export const deleteResidenceType = (id) =>
  axiosClient.delete(`/residence/types/${id}`);

// ---------------- Residence Subtypes ----------------

// Get all residence subtypes
export const getResidenceSubtypes = () =>
  axiosClient.get("/residence/subtypes");

// Create a new residence subtype
export const createResidenceSubtype = (subtypeData) =>
  axiosClient.post("/residence/subtypes", subtypeData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Update an existing residence subtype
export const updateResidenceSubtype = (id, subtypeData) =>
  axiosClient.put(`/residence/subtypes/${id}`, subtypeData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Delete a residence subtype
export const deleteResidenceSubtype = (id) =>
  axiosClient.delete(`/residence/subtypes/${id}`);

// ---------------- Residence Details ----------------

// Get all residence details
export const getResidenceDetails = () =>
  axiosClient.get("/residence/details");

// Create a new residence detail
export const createResidenceDetail = (detailData) =>
  axiosClient.post("/residence/details", detailData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Update an existing residence detail
export const updateResidenceDetail = (id, detailData) =>
  axiosClient.put(`/residence/details/${id}`, detailData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Soft-delete a residence detail
export const deleteResidenceDetail = (id) =>
  axiosClient.delete(`/residence/details/${id}`);
